"use strict";

exports.__esModule = true;
exports.default = void 0;
var _moment = _interopRequireDefault(require("moment"));
var _actions = _interopRequireDefault(require("./actions"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var _default = exports.default = {
  Id: {
    displayName: 'ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  CategoryImage: {
    displayName: 'Picture',
    type: 'RelationPicture',
    rules: [],
    value: '',
    format: 'base64',
    entity: {
      local: 'Category',
      foreign: 'CategoryImage'
    },
    add: _actions.default.addPicture,
    update: _actions.default.updatePicture,
    drop: _actions.default.dropPicture,
    sortable: true,
    filterable: false
  },
  Name: {
    displayName: 'Name',
    type: 'String',
    rules: [],
    value: '',
    sortable: true,
    filterable: true
  },
  // Published: {
  // 	displayName: 'Published',
  // 	type: 'Bool',
  // 	rules: [],
  // 	value: false,
  // 	sortable: true,
  // 	filterable: true,
  // },
  CreatedAt: {
    displayName: 'Created',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  UpdatedAt: {
    displayName: 'Updated',
    type: 'Date',
    format: value => value ? (0, _moment.default)(value).format('DD.MM.YYYY') : null,
    guarded: true,
    sortable: true,
    filterable: true
  },
  OwnerId: {
    displayName: 'Owner ID',
    type: 'String',
    guarded: true,
    sortable: true,
    filterable: true
  },
  ParentCategoryId: {
    displayName: 'Parent',
    type: 'Relation',
    expanded: 'ParentCategory',
    entity: {
      foreign: 'Category',
      filterString: value => `Name != null and Name.Contains("${value}")`,
      getDisplayName: entity => `${entity.Name}`,
      displayName: 'Parent'
    },
    sortable: true,
    filterable: false
  }
};
module.exports = exports.default;